import { Box, Link, Typography } from '@mui/material';

interface FootnoteProps {
  footnote: HTMLElement;
  number: number;
}

export default function Footnote({ footnote, number }: FootnoteProps) {
  return (
    <Box
      sx={{
        paddingY: 2,
        paddingLeft: 3,
        paddingRight: 6,
        backgroundColor: '#FFFFFF',
      }}
    >
      <Typography
        id={footnote.getAttribute('id') ?? undefined}
        variant='h6'
        component='p'
        sx={{
          paddingTop: 0,
          fontSize: 16,
        }}
      >
        <Link
          href={
            footnote.getAttribute('id')?.split('footnote-')[1]
              ? '#reference-' +
                footnote.getAttribute('id')?.split('footnote-')[1]
              : undefined
          }
          underline='hover'
          color='inherit'
          variant='h6'
          sx={{
            paddingTop: 0,
          }}
        >
          {number}
        </Link>
        <br />
        <Typography
          component='span'
          variant='body2'
          sx={{ overflowWrap: 'break-word' }}
          dangerouslySetInnerHTML={{
            __html: footnote.firstElementChild?.innerHTML ?? '',
          }}
        />
      </Typography>
    </Box>
  );
}
